<layout-base
	layoutClassName="menu-layout"
	[withContactForm]="true"
	[withThemeSelector]="true"
	[themesIsOpened]="themesIsOpened"
	(action)="handleAction($event)">

	<nav menu id="menu" layout-menu>
		<menu-links menu-content/>
	</nav>

	<header id="top-bar" content-top-bar layout-top-bar
		[withThemeSelector]="true"
		[title]="tenantTitle$ | async"
		[user]="currentUser$ | async"
		(action)="handleAction($event)">
	</header>

	<div content-main class="col-xl-11">
		<page-header>
			<a [routerLink]="federationsRoutePath" page-header-area="button" class="btn-link"
				translate="Actions.BackToFederations" data-cy="BackToFederations"></a>
		</page-header>

		<router-outlet></router-outlet>
	</div>
</layout-base>
